import React from 'react';

import { useTranslation } from 'react-i18next';

import { StackNavigationProp } from '@react-navigation/stack';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';
import { applyBoldStyle, applyNewLine } from 'utils/strings';

import DialogBody from 'components/Dialog/components/DialogBody';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

const {
    FTI_PARENTAL_CONTROL_CREATE_PIN_TITLE,
    FTI_PARENTAL_CONTROL_CREATE_PIN_DESCRIPTION,
    FTI_CONTINUE_BUTTON,
} = LANGUAGE_KEYS;

type Props = {
    navigation: StackNavigationProp<
        RouteNavigationParams,
        SCREEN.PIN_SETUP_INTRODUCTION
    >;
};

export default function PinSetupIntroduction({ navigation }: Props) {
    const { t } = useTranslation();

    const onPressContinue = () => {
        navigation.push(SCREEN.PIN_SETUP_CREATE);
    };

    return (
        <DialogBody
            title={FTI_PARENTAL_CONTROL_CREATE_PIN_TITLE}
            DescriptionComponent={() => (
                <Text
                    center
                    category={ETextCategory.body1}
                    color={ETextColor.light_grey}
                    style={styles.description}
                    {...(isWeb && { tabIndex: 0 })}
                >
                    {applyBoldStyle(
                        applyNewLine(
                            t(FTI_PARENTAL_CONTROL_CREATE_PIN_DESCRIPTION),
                        ),
                        styles.description,
                    )}
                </Text>
            )}
            actionButtonTitle={FTI_CONTINUE_BUTTON}
            actionButtonStyle={styles.button}
            actionButtonTextStyle={styles.buttonText}
            handleActionButtonPress={onPressContinue}
            actionButtonFillColor={COLOR.primary}
            style={styles.container}
        />
    );
}
